<script setup lang="ts">
import type { ButtonProps } from '#layers/ui/public';
import { reactiveOmit } from '@vueuse/core';
import { computed, mergeProps } from 'vue';

const props = withDefaults(defineProps<{
	icon?: string;
	label?: string;
	color?: ButtonProps['color'];
	to?: ButtonProps['to'];
	size?: 'sm' | 'md';
}>(), {
	color: 'neutral',
	size: 'md',
});

const commonProps = computed<ButtonProps>(() => ({
	variant: 'outline',
	size: 'xs',
	class: ['bg-muted font-mono text-xs', props.size === 'sm' ? 'py-0.5 px-1.5' : ''],
	ui: {
		leadingIcon: 'text-toned',
	},
}));

const forwarded = reactiveOmit(props, 'size');
</script>

<template>
	<DButton v-bind="mergeProps(commonProps as Record<string, unknown>, forwarded)">
		<slot />
	</DButton>
</template>
